/* ==========================================================================
 * custom-devtools-deterrent.js
 * Site-wide casual-tampering DETERRENT for the client-side price protection.
 *
 * IMPORTANT CAVEAT: This is a DETERRENT ONLY. It CANNOT fully block DevTools.
 * A determined user can still open DevTools from the browser menu, disable
 * JavaScript, use a different browser/proxy, or POST directly to the backend
 * (variant_combination.php). The real, permanent fix for price tampering is
 * server-side price recomputation. This only raises the bar against casual users.
 *
 * Designed to NOT break legitimate use:
 *   - Right-click is only suppressed OUTSIDE form fields, so right-click
 *     copy/paste inside inputs/textareas keeps working.
 *   - Text selection is NOT disabled.
 *   - Normal clicking, the configurator and add-to-cart are untouched.
 * ========================================================================== */
(function () {
  'use strict';

  // Allow right-click / shortcuts inside editable fields so copy/paste & typing work.
  function isEditable(el) {
    if (!el) return false;
    var tag = (el.tagName || '').toUpperCase();
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
  }

  // 1) Disable right-click context menu (except in editable fields).
  document.addEventListener('contextmenu', function (e) {
    if (isEditable(e.target)) return; // keep right-click in form fields
    e.preventDefault();
  });

  // 2) Block common DevTools / view-source keyboard shortcuts.
  //    These combos are not used for typing, so inputs are unaffected.
  document.addEventListener('keydown', function (e) {
    var key = (e.key || '').toLowerCase();

    // F12
    if (e.key === 'F12') { e.preventDefault(); return; }

    // Ctrl+Shift+I / J / C  (DevTools, console, element picker)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey &&
        (key === 'i' || key === 'j' || key === 'c')) {
      e.preventDefault();
      return;
    }

    // Ctrl+U (view source)
    if ((e.ctrlKey || e.metaKey) && key === 'u') {
      e.preventDefault();
      return;
    }
  });

  // 3) Basic DevTools-open detection -> blank the page.
  //    Uses a debugger-timing probe rather than a window-size heuristic, because
  //    size heuristics false-positive on narrow windows / docked panels / zoom.
  //    When DevTools is closed the `debugger` statement is a no-op (fast); when
  //    open and paused it takes noticeably longer. Threshold kept conservative.
  //    NOTE: still imperfect — may false-positive if a real visitor opens DevTools.
  var blanked = false;
  function blankPage() {
    if (blanked) return;
    blanked = true;
    try {
      document.documentElement.innerHTML =
        '<div style="font-family:sans-serif;padding:40px;text-align:center;">' +
        'Something went wrong, please refresh and try again.</div>';
    } catch (err) { /* no-op */ }
  }

  function detect() {
    var start = (window.performance && performance.now) ? performance.now() : Date.now();
    // eslint-disable-next-line no-debugger
    debugger;
    var elapsed = ((window.performance && performance.now) ? performance.now() : Date.now()) - start;
    if (elapsed > 300) { // conservative threshold to limit false positives
      blankPage();
    }
  }

  // Run the probe occasionally (not in a tight loop) to minimise overhead.
  setInterval(detect, 3000);
})();
